var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 20px 0", "background-color": "#2D2D2D" }
    },
    [
      _c(
        "el-col",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            padding: "0 16px"
          },
          attrs: { span: 24 }
        },
        [
          _c(
            "el-button",
            { staticClass: "btn-view-more", attrs: { type: "primary" } },
            [_vm._v("\n      View more\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        {
          staticStyle: { "margin-top": "20px", padding: "0 16px 25px 16px" },
          attrs: { span: 24 }
        },
        [
          _c("span", { staticClass: "content-style" }, [
            _vm._v(
              "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis\n      suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis\n      autem vel eum iure reprehenderit qui in ea voluptate velit esse quam\n      nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo\n      voluptas nulla pariatur?"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-648b1c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648b1c7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/viewMore.vue
// module id = null
// module chunks = 